import { Fade } from "@material-ui/core";
import { useEffect, useState } from "react";
import { BsExclamationCircle } from "react-icons/bs";
import { Control, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FaFileAlt } from "react-icons/fa";
import CustomSwitch from "shared/components/Switch/CustomSwitch";
import CloudAnexo from "shared/components/input/CloudAnexo";
import TextInput from "shared/components/input/TextInput";
import { Section } from "shared/components/section/Section";
import { FileToBase64 } from "shared/util/functions/file/FileFunctions";
import { AnexoType } from "types/anexo/AnexoType";
import { ConfigurarGroupPayForm } from "./TelaConfiguracoesGroupPay";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { downloadFile } from "shared/util/functions/download/DownloadFunctions";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";
import {
  ResponsePayloadBuscaConfiguracaoGroupPay,
} from "types/response/groupPay/ResponsePayloadBuscaConfiguracaoGroupPay";
import toast from "react-hot-toast";
import showAlert from "shared/util/functions/alert/showAlert";

interface SecaoConsultarNotasFiscaisProps {
  control: Control<ConfigurarGroupPayForm, any>;
  register: UseFormRegister<ConfigurarGroupPayForm>;
  setValue: UseFormSetValue<ConfigurarGroupPayForm>;
  condominioId: number;
  setAnexosCertificado: React.Dispatch<React.SetStateAction<AnexoType[]>>;
  setCertificadoDigitalBase64: React.Dispatch<React.SetStateAction<string | null>>;
  setPermitirBuscaLancamentoNF: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  setPermitirMailReader: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  onChangeValues: Function;
}

const SecaoConsultarNotasFiscais: React.FC<SecaoConsultarNotasFiscaisProps> = (props) => {
  const [senhaPrefeitura, setSenhaPrefeitura] = useState<string>();
  const [anexosCertificado, setAnexosCertificado] = useState<AnexoType[]>([]);
  const [usuarioPrefeitura, setUsuarioPrefeitura] = useState<string>();
  const [nomeCertificadoDigital, setNomeCertificadoDigital] = useState<string>();
  const [senhaCertificadoDigital, setSenhaCertificadoDigital] = useState<string>();
  const [certificadoDigitalBase64, setCertificadoDigitalBase64] = useState<string | null>("");
  const [permitirBuscaLancamentoNotaFiscal, setPermitirBuscaLancamentoNotaFiscal] = useState<boolean>();
  const [stackTraceErroMunicipal, setStackTraceMunicipal] = useState<string>();
  const [stackTraceErroFederal, setStackTraceFederal] = useState<string>();
  const [permitirMailReader, setPermitirMailReader] = useState<boolean>();
  const [mailReaderPassword, setMailReaderPassword] = useState<string>();
  const [mailReaderEmail, setMailReaderEmail] = useState<string>();


  useEffect(() => {
    http
      .get<Cond21CloudResponse<ResponsePayloadBuscaConfiguracaoGroupPay>>(
        api.groupPay.getConfiguracaoGroupPay + `/${props.condominioId}`,
      )
      .then((response) => {
        setSenhaPrefeitura(response.data.payload.senhaPrefeitura);
        setUsuarioPrefeitura(response.data.payload.usuarioPrefeitura);
        setNomeCertificadoDigital(response.data.payload.nomeCertificadoDigital);
        setSenhaCertificadoDigital(response.data.payload.senhaCertificadoDigital);
        props.setValue("senhaPrefeitura", response.data.payload.senhaPrefeitura ?? "");
        props.setValue("usuarioPrefeitura", response.data.payload.usuarioPrefeitura ?? "");
        props.setValue("senhaCertificadoDigital", response.data.payload.senhaCertificadoDigital ?? "");
        setAnexosCertificado(criarAnexoCertificado(response.data.payload));
        setCertificadoDigitalBase64(response?.data?.payload?.certificadoDigitalBase64);
        setPermitirBuscaLancamentoNotaFiscal(response.data.payload.permitirBuscaLancamentoNotaFiscal);
        setStackTraceMunicipal(response.data.payload.stackTraceErroMunicipal);
        setStackTraceFederal(response.data.payload.stackTraceErroFederal);
        setPermitirMailReader(response.data.payload.permitirBuscaLancamentoDespesasPorLeituraEmail);
        setMailReaderEmail(response.data.payload.readerEmail);
        setMailReaderPassword(response.data.payload.readerPassword);


        props.setPermitirBuscaLancamentoNF(response.data.payload.permitirBuscaLancamentoNotaFiscal);
        props.setPermitirMailReader(response.data.payload.permitirBuscaLancamentoDespesasPorLeituraEmail);
        props.setCertificadoDigitalBase64(response?.data?.payload?.certificadoDigitalBase64);
        props.setAnexosCertificado(criarAnexoCertificado(response.data.payload));
      });
  }, []);

  const criarAnexoCertificado = (tipo: ResponsePayloadBuscaConfiguracaoGroupPay): AnexoType[] => {
    let anexos: AnexoType[] = [];

    if (tipo.nomeCertificadoDigital && tipo.certificadoDigitalBase64) {
      let anexo: AnexoType = { nome: tipo.nomeCertificadoDigital, base64: tipo.certificadoDigitalBase64 };
      anexos.push(anexo);
    }
    return anexos;
  };

  const renderSecaoConsultarNotasFiscais = () => {
    return (
      <Section title="Consulta de Notas Fiscais" icon={FaFileAlt}>
        {renderSwichConsultaNotasFiscais()}
        <Fade in={permitirBuscaLancamentoNotaFiscal} timeout={400}>
          <div>
            {permitirBuscaLancamentoNotaFiscal && renderSpanTextoInformativo()}
            {permitirBuscaLancamentoNotaFiscal && renderErrosConfiguracao()}
            {permitirBuscaLancamentoNotaFiscal && renderCamposDadosDeAcesso()}
          </div>
        </Fade>
        {renderSwitchMailReader()}
        <Fade in={permitirMailReader} timeout={400}>
          <div>{permitirMailReader && renderCamposMailReader()}</div>
        </Fade>
      </Section>
    );
  };

  const renderSwitchMailReader = () => {
    return (
      <div className="d-flex justify-content-between m-3">
        <CustomSwitch
          key={"switch-section-mail-reader"}
          labelDireito="Permitir a busca e lançamento de despesas por leitura de e-mail"
          checked={permitirMailReader}
          usarValidacaoParaFormulario={false}
          onChange={handleTogglePermitirMailReader}
        />
      </div>
    );
  };

  const renderCamposMailReader = () => {
    return (
      <div className="m-3 d-flex">
        <div className="pe-3">
          <span>Configuração de E-mail</span>
          <div className="mt-3 d-flex">
            {renderCampoEmailRender()}
            {/*renderCampoSenhaReader()*/}
          </div>
        </div>
      </div>
    );
  };

  const renderCampoEmailRender = () => {
    return (
      <TextInput
        id="email-mailreader"
        key="email-mailreader"
        name="mailReaderEmail"
        label="E-mail"
        className="pe-4"
        control={props.control}
        register={props.register}
        setValue={props.setValue}
        defaultValue={mailReaderEmail}
        usarValidacaoParaFormulario
        onChange={() => props.onChangeValues()}
        readOnly={true}
        enableCopy={true}
      />
    );
  };

  const handleTogglePermitirMailReader = async () => {
    const novoValor = !permitirMailReader;

    setPermitirMailReader(novoValor);
    props.setPermitirMailReader(novoValor);

    if (novoValor) {
      try {
        const response = await http.get<Cond21CloudResponse<string>>(
          `${api.groupPay.getEmailParaLeitura}/${props.condominioId}`,
        );

        const emailGerado = response.data.payload;

        setMailReaderEmail(emailGerado);
        props.setValue("mailReaderEmail", emailGerado);

        props.onChangeValues();
      } catch (error) {
        console.error("Erro ao chamar o endpoint para montar o e-mail:", error);
      }
    } else {
      setMailReaderEmail("");
      props.setValue("mailReaderEmail", "");
      props.onChangeValues();
    }
  };

  const renderCampoSenhaReader = () => {
    return (
      <TextInput
        id="password-mailreader"
        key="password-mailreader"
        name="mailReaderPassword"
        label="Senha"
        className="pe-4"
        isPassword
        control={props.control}
        register={props.register}
        setValue={props.setValue}
        defaultValue={mailReaderPassword}
        usarValidacaoParaFormulario
        onChange={() => props.onChangeValues()}
      />
    );
  };

  const renderSwichConsultaNotasFiscais = () => {
    return (
      <div className="d-flex justify-content-between m-3">
        <CustomSwitch
          key={"switch-section-consulta-notas-fiscais"}
          labelDireito="Permitir a busca e lançamento de notas fiscais de produto e serviço para o CNPJ do condomínio"
          checked={permitirBuscaLancamentoNotaFiscal}
          usarValidacaoParaFormulario={false}
          onChange={() => {
            setPermitirBuscaLancamentoNotaFiscal(!permitirBuscaLancamentoNotaFiscal);
            props.setPermitirBuscaLancamentoNF(!permitirBuscaLancamentoNotaFiscal);
            props.onChangeValues();
          }}
        />
      </div>
    );
  };

  const renderSpanTextoInformativo = () => {
    return (
      <span className="m-3">
        Para realização da busca, é necessário informar os dados de acesso a prefeitura ou disponibilizar o certificado
        digital A1
      </span>
    );
  };

  const renderErrosConfiguracao = () => {
    return (
      <div className="m-3">
        {stackTraceErroMunicipal &&
          <div className="row">
            <span>
              <BsExclamationCircle
                onClick={() => showAlert({
                  texto: stackTraceErroMunicipal,
                  tipoAlerta: "OK_ALERT",
                  //onConfirm: () => fecharModal(),
                })}
                className="cursor-pointer"
                size={15}
                color="#ed5565"
              />
              <span className="m-l" style={{ color: "#ed5565" }}>Erro ao configurar busca de notas municipais!</span>
            </span>
          </div>
        }

        {stackTraceErroFederal &&
          <div className="row">
            <span>
              <BsExclamationCircle
                onClick={() => showAlert({
                  texto: stackTraceErroFederal,
                  tipoAlerta: "OK_ALERT",
                  //onConfirm: () => fecharModal(),
                })}
                className="cursor-pointer"
                size={15}
                color="#ed5565"
              />
              <span className="m-l"
                    style={{ color: "#ed5565" }}>Erro ao configurar busca de notas no portal nacional!</span>
            </span>
          </div>
        }
      </div>
    );
  };

  const renderCamposDadosDeAcesso = () => {
    return (
      <div className="m-3 d-flex">
        <div className="pe-3">
          <span>Acesso</span>
          <div className="mt-3 d-flex">
            {renderCampoUsuario()}
            {renderCampoSenha()}
          </div>
        </div>
        <div>
          <span className="ms-3">Certificado</span>
          <div className="mt-3 d-flex borda-campo-acesso">
            {renderCampoCertificadoDigital()}
            {renderCampoSenhaCertificado()}
          </div>
        </div>
      </div>
    );
  };

  const renderCampoUsuario = () => {
    return (
      <TextInput
        id="usuario"
        key="usuario-input"
        name="usuarioPrefeitura"
        label="Usuário"
        control={props.control}
        register={props.register}
        setValue={props.setValue}
        className="pe-4"
        defaultValue={usuarioPrefeitura}
        onChange={() => props.onChangeValues()}
        usarValidacaoParaFormulario
      />
    );
  };

  const renderCampoSenha = () => {
    return (
      <TextInput
        id="senha"
        key="senha-input"
        name="senhaPrefeitura"
        label="Senha"
        control={props.control}
        register={props.register}
        setValue={props.setValue}
        isPassword
        defaultValue={senhaPrefeitura}
        onChange={() => props.onChangeValues()}
        usarValidacaoParaFormulario
      />
    );
  };

  const renderCampoCertificadoDigital = () => {
    return (
      <div className="mt-2 me-4 ms-3">
        <CloudAnexo
          accept=".pfx, .p12"
          anexos={anexosCertificado}
          onAddAnexo={onAddAnexo}
          onDownload={onDownload}
          onRemoveAnexo={onRemoveAnexo}
          mensagemDeErro="O formato do arquivo enviado é inválido. Extensões válidas .pfx ou p12."
          limiteDeAnexos={1}
          extensoesAceitas={["pfx", "p12"]}
        />
      </div>
    );
  };

  const onDownload = (anexo: AnexoType) => {
    anexo.base64 && downloadFile(anexo.base64, anexo.nome);
  };

  const onAddAnexo = async (file: File) => {
    let base64 = "";
    let anexoCertificado: AnexoType = { nome: file.name };
    await FileToBase64(file).then((result: string) => (base64 = result));
    setCertificadoDigitalBase64(base64);
    setAnexosCertificado([anexoCertificado]);
    props.setAnexosCertificado([anexoCertificado]);
    props.setCertificadoDigitalBase64(base64);
    props.onChangeValues();
  };

  const onRemoveAnexo = (anexo: AnexoType) => {
    setAnexosCertificado([]);
    setCertificadoDigitalBase64(null);
    props.setAnexosCertificado([]);
    props.setCertificadoDigitalBase64(null);
    props.onChangeValues();
    toast.success("Certificado removido com sucesso.");
  };

  const renderCampoSenhaCertificado = () => {
    return (
      <TextInput
        id="senha-certificado"
        key="senha-certificado-input"
        name="senhaCertificadoDigital"
        label="Senha do certificado"
        control={props.control}
        setValue={props.setValue}
        register={props.register}
        isPassword
        onChange={() => props.onChangeValues()}
        defaultValue={senhaCertificadoDigital}
        usarValidacaoParaFormulario
      />
    );
  };

  return <>{renderSecaoConsultarNotasFiscais()}</>;
};

export default SecaoConsultarNotasFiscais;
